import { useState, useEffect } from 'react'

export default function Banner() {
  const [bannerData, setBannerData] = useState(null)

  useEffect(() => {
    fetch('https://api.bittercube.com/api/banner.json')
      .then(response => response.json())
      .then(data => setBannerData(data[0]))
  }, [])

  if (!bannerData || !bannerData.display_recipe_page_banner) return null

  return (
    <div id="recipe-banner" className="bg-gold py-5">
      <div className="container max-w-5xl mx-auto py-0 text-center">
        <div dangerouslySetInnerHTML={{__html: bannerData.recipe_banner_text_html}}></div>
      </div>
    </div>
  )
}